import type { CurrentUserDto } from '@/lib/api/admin'

// Mirrors the server's GuardianRole ordinals (IUserContextService.cs).
const ROLE_RANK: Record<string, number> = {
  Viewer: 1,
  Approver: 2,
  ComplianceOfficer: 3,
  SecurityAdmin: 4,
  GlobalAdmin: 5,
}

/**
 * Whether the signed-in user may accept, reject, stage, waive, apply or undo
 * drifts. Mirrors the Container gate on the DSC and TCM drift write routes:
 * Approver or higher (ordinal, so ComplianceOfficer passes), and a Platform
 * Admin always passes. An unknown role string fails closed, as the server
 * parses it to Viewer.
 *
 * While `/me` is still loading (or failed) this returns true, so an Approver
 * never loses the buttons to a slow call. The server is the real check; this
 * only keeps a Viewer from clicking into a 403.
 */
export function canChangeDrifts(
  user: Pick<CurrentUserDto, 'role' | 'isPlatformAdmin'> | null | undefined,
): boolean {
  if (!user) return true
  if (user.isPlatformAdmin) return true
  const rank = ROLE_RANK[user.role]
  return rank !== undefined && rank >= ROLE_RANK.Approver
}
